export default {
  beforeCreate() {
    // Apply security. Force the user to the login page if they are attempting to
    // get to anywhere except the root page or the login page
    var path = this.$route.path
    console.log('Checking security for page:', path)
    if (this.$store.state.useSecurity) {
      if (!this.$root.isUserAlreadyLoggedIn()) {
        console.log('User may not already be checked in. Try autoLogin...')
        try {
          this.$root.autoLogin().then(
            function(success) {
              console.log('autoLogin.status: ', success)
              if (success) {
                // The user is logged in reroute if they are at the login screen
                if ('/login' === path) {
                  this.$router.replace({
                    name: 'Home',
                    params: { section: 'top' }
                  })
                }
                // Make sure and tell App to show the proper header!
                this.$parent.changeHeader(true)
              } else {
                // Make sure and tell App to show the proper header!
                this.$parent.changeHeader(false)
                // The user is NOT logged in. They should be at the login screen. Reroute
                this.$router.replace({
                  name: 'Login',
                  params: { section: 'top' }
                })
              }
            }.bind(this)
          )
        } catch (error) {
          console.error('autoLogin.catch Error:', error)
        }
      } else {
        console.log('Security: Already logged in...Have a nice day!')
        // Make sure and tell App to show the proper header!
        this.$parent.changeHeader(true)
      }
    } else {
      // end if useSecurity
      console.log('No Site Security...')
      // Make sure and tell App to show the proper header!
      this.$parent.changeHeader(true)
    }
  }
}
